import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';

import { MembershipService } from '@core/services/membership';

@Component({
  selector: 'app-membership-reports',
  standalone: true,
  imports: [CommonModule, ButtonModule, ProgressSpinnerModule, TooltipModule],
  templateUrl: './reports.html',
  styleUrl: './reports.scss'
})
export class MembershipReportsComponent {
  private readonly membershipService = inject(MembershipService);

  readonly summaryResource = this.membershipService.createPackagesSummaryResource();

  refreshSummary(): void {
    this.summaryResource.reload();
  }

  formatDateTime(date: Date | string | null | undefined): string {
    if (!date) return 'N/A';
    try {
      return new Date(date).toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
      });
    } catch {
      return 'Invalid date';
    }
  }
}
